export const STRIPE_ACCOUNT_STATUS_VARIANTS = {
  not_created: 'secondary',
  pending: 'warning',
  restricted: 'warning',
  active: 'success',
  disabled: 'danger',
}

export const BUSINESS_VERIFICATION_STATUS_VARIANTS = {
  verified: 'success',
  pending: 'warning',
  action_required: 'danger',
}

export function getStripeAccountStatus(stripeStatus) {
  return stripeStatus?.stripe_account_status || 'not_created'
}

export function isCharityStripeComplete(stripeStatus) {
  return (
    getStripeAccountStatus(stripeStatus) === 'active' &&
    stripeStatus?.stripe_payouts_enabled
  )
}

export function getBusinessVerificationBadgeKey(stripeStatus) {
  if (stripeStatus?.verified_by_stripe) return 'verified'
  const status = getStripeAccountStatus(stripeStatus)
  if (status === 'restricted' || status === 'disabled') return 'action_required'
  return 'pending'
}

export function isBusinessStripeVerified(stripeStatus) {
  return stripeStatus?.verified_by_stripe === true
}

export function extractStripeApiError(error, fallback = 'Request failed') {
  const data = error?.response?.data
  if (typeof data?.error === 'string' && data.error.length > 0) {
    return data.error
  }
  if (data?.errors?.full_messages?.[0]) {
    return data.errors.full_messages[0]
  }
  if (Array.isArray(data?.errors) && data.errors[0]) {
    return data.errors[0]
  }
  return error?.message || fallback
}

export function isExistingStripeAccountError(message) {
  if (!message) return false
  const lower = message.toLowerCase()
  return lower.includes('already') || lower.includes('exists')
}
